import React from "react";
import { NavLink } from "react-router-dom";
import { Tabs, Tab } from "@curves/ui-base";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import { MEMBERS_OVERVIEW_TABS } from "@icoach/constants/";

const MemberOverviewTabsHeader = props => {
	const { value: propsValue, handleTabsValue = () => {} } = props;
	const handleChange = (event, newValue) => {
		handleTabsValue && handleTabsValue(newValue);
	};

	return (
		<React.Fragment>
			<Tabs className="pl-2" value={propsValue} onChange={handleChange} variant="scrollable" allowScrollButtonsMobile>
				<Tab label="條件篩選" value={"normal"} component={NavLink} to={CLUB_MEMBERS_ROUTER.MEMBER_OVERVIEW.GET_TABS_PATH(MEMBERS_OVERVIEW_TABS.NORMAL)} />
				<Tab label="快速名單" value={"quick"} component={NavLink} to={`${CLUB_MEMBERS_ROUTER.MEMBER_OVERVIEW.GET_QUICK_PATH(1)}`} />
			</Tabs>
		</React.Fragment>
	);
};

export default MemberOverviewTabsHeader;
